import { render, staticRenderFns } from "./draw-with-video.vue?vue&type=template&id=92ef28a2&scoped=true&"
import script from "./draw-with-video.vue?vue&type=script&lang=ts&"
export * from "./draw-with-video.vue?vue&type=script&lang=ts&"
import style0 from "./draw-with-video.vue?vue&type=style&index=0&id=92ef28a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ef28a2",
  null
  
)

export default component.exports